import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import {
  Formik,
  Form as FormikForm,
} from 'formik';

import Modal from 'components/new_ui/Modal/Modal';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext as useTeamContext } from 'components/Managers/Teams/Context';
import { useContext } from '../../Context';

export default function Index({ member, closeEditMember }) {
  const { actions, dispatch } = useContext();
  const { state: stateTeam } = useTeamContext();

  const teams = stateTeam && stateTeam.teams ? stateTeam.teams.map((item) => ({
    label: item.attributes.title,
    value: item.id,
  })) : [];

  const formSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
    team: Yup.string().typeError('Please, choose team'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    actions.update(
      dispatch,
      member.id,
      values,
      () => {
        setSubmitting(false);
        closeEditMember();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          firstName: member.attributes.first_name,
          lastName: member.attributes.last_name,
          email: member.attributes.email,
          team: member.attributes.team_id,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalTextField name="firstName" label="First Name" required />
            <HorizontalTextField name="lastName" label="Last Name" required />
            <HorizontalTextField name="email" type="email" label="Email" required />
            <HorizontalSelectField name="team" label="Team" options={teams} required />

            <footer>
              <Button
                variant="outline-primary"
                onClick={() => closeEditMember()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Index.propTypes = {
  member: PropTypes.object.isRequired,
  closeEditMember: PropTypes.func.isRequired,
};
